module.exports = __webpack_public_path__ + "static/media/contact-bg.8fef0ec5.jpg";